import { NgClass, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { LineHeightByComponent } from '@df/ui/common/line-height-by.component';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { BehaviorSubject } from 'rxjs';
/**
 * Sample usage:
 *
 *     <expandable expandableTitle="Title">
 *         Lorem ipsum dolor
 *     </expandable>
 */
@Component({
    selector: 'expandable',
    templateUrl: './expandable.html',
    styleUrls: ['./expandable.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [OffClickModule, NgClass, LineHeightByComponent, ToggleModule, HideUpComponent, CommonModule]
})
export class ExpandableComponent implements OnInit {
    /**
     * Title
     */
    @Input()
    expandableTitle?: string;

    @Input()
    expandableLayout: 'default' | 'filled' = 'default';

    @Input()
    whiteMode = false;

    @Input()
    toggleState = false;

    @Input()
    @HostBinding('class._fadeOut')
    fadeOut = false;

    @Input()
    offClickClose = true;

    /**
     * If is open
     */
    readonly openState = new BehaviorSubject(this.toggleState);

    /**
     * Dependencies
     */
    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    ngOnInit(): void {
        if (this.toggleState) {
            this.openState.next(true);
        }
    }

    /**
     * Toggle state
     */
    toggle(to = !this.openState.value) {
        this.openState.next(to);
        this.detectChanges();
    }

    private detectChanges() {
        this.changeDetectorRef.detectChanges();
    }
}
